// extracted by mini-css-extract-plugin
export default {"notification__items":"notification__items___tX1E"};